import { LazyModule } from 'owa-bundling';
import { EditorPluginEx } from 'owa-editor';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { LazyAction } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "SmartComposePlugin" */ './plugin/SmartComposePlugin')
);

export type LazySmartComposePlugin = LazyPlugin<EditorPluginEx>;

export let LazySmartComposePluginClass = createLazyPlugin(
    lazyModule,
    m => m.default,
    'SmartCompose',
    null
);

export let updateRecipientsForSmartCompose = new LazyAction(
    lazyModule,
    m => m.updateRecipientsForSmartCompose
);
